import { AbilityRole } from "./abilitiesByRole"
import store from "./store"
import { KeyDict } from "./types"

//Multiple function signatures & return types for different parameters
function roleNames (role: string): string;
function roleNames (): KeyDict<string>;

//Function implementation
function roleNames (role: string = ''): string|KeyDict<string> {
  const defaultNames: KeyDict<string> = {
    [AbilityRole.Admin]: 'Admin',
    [AbilityRole.Member]: 'Producer',
    [AbilityRole.GuestCaster]: 'Talent',
    [AbilityRole.Station]: 'Station',
    [AbilityRole.SuperUser]: 'Superuser',
    [AbilityRole.AudioEngineer]: 'Audio Engineer',
    [AbilityRole.CrewObserver]: 'Crew Observer'
  }

  if (role === AbilityRole.SuperUser) {
    return defaultNames[role]
  }
  // We don't want to include superuser when the whole list is requested, but we still want
  // to have the benefit of a TS Record to ensure that all other AbilityRoles are included.
  const names: KeyDict<string> = { ...defaultNames }
  delete names[AbilityRole.SuperUser]
  for (const [id, role] of Object.entries(store.state.abilities.teamRoles)) {
    names[id] = role.name
  }

  if (!role) return names
  if (role in names) return names[role]
  return 'Talent'
}

export default roleNames
